var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiAnim({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24,
    fill: "#0C6DC7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 22.564C44 21.1482 42.8386 20 41.4068 20C39.9748 20 38.8134 21.1482 38.8134 22.564C38.8134 23.9799 39.9748 25.1281 41.4068 25.1281C42.8386 25.1281 44 23.9799 44 22.564Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5819 35.7736L31.5128 41.6935C31.6399 41.885 31.8542 42 32.0836 42H35.381C35.9315 42 36.2576 41.3823 35.948 40.9259L31.9626 35.0507C34.4145 34.1342 36.0969 32.1612 36.0969 29.0201V28.9641C36.0969 27.129 35.5193 25.6013 34.4429 24.517C33.1764 23.237 31.2739 22.5421 28.82 22.5421H20.6857C20.307 22.5421 20 22.8499 20 23.2296V41.3125C20 41.6922 20.307 42 20.6857 42H23.5597C23.9384 42 24.2454 41.6922 24.2454 41.3125V35.7736H27.5819ZM28.4625 26.4061C30.5287 26.4061 31.7971 27.3506 31.7971 29.1858V29.2417C31.7971 30.8812 30.6135 31.9935 28.5453 31.9935H24.2454V26.4061H28.4625Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6627 27.7885C43.6627 27.4088 43.3557 27.101 42.977 27.101H40.1596C39.7809 27.101 39.4739 27.4088 39.4739 27.7885V41.3125C39.4739 41.6922 39.7809 42 40.1596 42H42.977C43.3557 42 43.6627 41.6922 43.6627 41.3125V27.7885Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiAnim);
export default __webpack_public_path__ + "static/media/ri_anim.92ca6ca59761501da39d96df9ac1c935.svg";
export { ForwardRef as ReactComponent };